import { theme } from 'styled';

import { IconProps } from './Icon';

export const PaymentOutlineIcon = ({ width, height, color }: IconProps) => {
  const DEFAULT_WIDTH = '18px';
  const DEFAULT_HEIGHT = '18px';
  const DEFAULT_COLOR = theme.colors.text.primary;

  return (
    <svg
      color={color || DEFAULT_COLOR}
      enableBackground="new 0 0 512 512"
      height={height || DEFAULT_HEIGHT}
      viewBox="0 0 512 512"
      width={width || DEFAULT_WIDTH}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path d="m256 512c-68.38 0-132.668-26.628-181.02-74.98s-74.98-112.64-74.98-181.02 26.629-132.667 74.98-181.02 112.64-74.98 181.02-74.98 132.668 26.628 181.02 74.98 74.98 112.64 74.98 181.02-26.629 132.667-74.98 181.02-112.64 74.98-181.02 74.98zm0-480c-123.514 0-224 100.486-224 224s100.486 224 224 224 224-100.486 224-224-100.486-224-224-224z" />
        <path d="m256 240c-22.056 0-40-17.944-40-40s17.944-40 40-40 40 17.944 40 40c0 8.836 7.163 16 16 16s16-7.164 16-16c0-34.201-23.978-62.888-56-70.186v-17.814c0-8.836-7.163-16-16-16s-16 7.164-16 16v17.814c-32.022 7.298-56 35.985-56 70.186 0 39.701 32.299 72 72 72 22.056 0 40 17.944 40 40s-17.944 40-40 40-40-17.944-40-40c0-8.836-7.163-16-16-16s-16 7.164-16 16c0 34.201 23.978 62.888 56 70.186v17.814c0 8.836 7.163 16 16 16s16-7.164 16-16v-17.814c32.022-7.298 56-35.985 56-70.186 0-39.701-32.299-72-72-72z" />
      </g>
    </svg>
  );
};
